<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.acwName" style="width: 140px;" size="small" placeholder="请输入名称"
                        clearable></el-input>
                    <el-select size="small" v-model="formDatas.dmDelete" clearable @change="partserch" placeholder="请选择"
                        v-if="post == 2" style="width: 130px">
                        <el-option label="已删除" :value="2" key="2"></el-option>
                        <el-option label="未删除" :value="1" key="1"></el-option>
                    </el-select>
                    <el-button type="info" size="small" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-dropdown size="small" split-button type="warning" style="margin:0 10px;" @click="Out()"
                        @command="Out">
                        导出
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item style="background-color: #E6A23C;color: white;"
                                command="1">导出全部</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown> -->
                    <!-- <el-button type="danger" size="small" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="small" style="margin-right: 20px" @click="BoxOpen">新增公章模板
                    </el-button>

                    <!-- <el-button type="warning" size="small" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="asmrId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-dialog :title="edit == true ? '编辑公章模板 ' : '新增公章模板 '" :before-close="handleClose" :visible.sync="dialog"
                direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="公章模板" prop="asmType">
                                <el-select v-model="form.asmType" placeholder="请选择" filterable clearable
                                    style="width: 150px;">
                                    <el-option v-for="(item, index) in asmType_arr" :label="item.asmTypeDes"
                                        :value="item.asmType" :key="item.asmType"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="文件" prop="file">
                                <!-- <cj-upload ref="Imgupload" @fileChange="TextFileChange" :filearr="TextFileList"
                                    @removeAfter="form.file = ''" :limit="1" accept=".docx"
                                    style="margin: 10px 5px 5px;" type="text"
                                    @textFIlePreview="(val) => { textFIlePreview(val, 'file') }">
                                </cj-upload> -->
                                <el-upload ref="Upload" class="upload-demo" action="#" :auto-upload="false"
                                    :on-change="handlePreview" :on-remove="handleRemove" multiple :limit="1"
                                    :file-list="TextFileList" accept=".docx">
                                    <el-button size="small" type="primary">点击上传</el-button>
                                    <div slot="tip" class="el-upload__tip">只能上传docx文件</div>
                                </el-upload>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">``
                        确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog :visible.sync="WorkGgShow" width="70%" top="8vh" title="编辑公章模板 参数"
                :before-close="handleWorkGgClose">
                <el-form ref="formGg" :model="formGg" label-position="top" label-width="150px" @submit.native.prevent>
                    <el-form-item label="文件名" prop="asmrFileName">
                        <el-input v-model="formGg.asmrFileName" style="width: 80%;" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="公章一横向位置(一个字约为12)" prop="asmrLocationOneHorizontal">
                        <span style="margin-right: 10px;">向左移动</span> <el-input-number
                            v-model="formGg.asmrLocationOneHorizontal" :step="12" style="width: 40%;"
                            placeholder="请输入"></el-input-number> <span style="margin-left: 10px;">向右移动</span>
                        <!-- <el-input v-model="formGg.asmrLocationOneHorizontal" type="number" ></el-input> -->
                    </el-form-item>
                    <el-form-item label="公章一纵向位置(一行约为24)" prop="asmrLocationOneVertical">
                        <span style="margin-right: 10px;">向上移动</span> <el-input-number
                            v-model="formGg.asmrLocationOneVertical" :step="24" style="width: 40%;"
                            placeholder="请输入"></el-input-number> <span style="margin-left: 10px;">向下移动</span>
                        <!-- <el-input v-model="formGg.asmrLocationOneVertical" type="number" style="width: 80%;" placeholder="请输入"></el-input> -->
                    </el-form-item>
                    <el-form-item label="公章二横向位置(一个字约为12)" prop="asmrLocationTwoHorizontal">
                        <span style="margin-right: 10px;">向左移动</span> <el-input-number
                            v-model="formGg.asmrLocationTwoHorizontal" :step="12" style="width: 40%;"
                            :disabled="formGg.asmType != 1" placeholder="请输入"></el-input-number> <span
                            style="margin-left: 10px;">向右移动</span>
                        <!-- <el-input v-model="formGg.asmrLocationTwoHorizontal" type="number" :disabled="formGg.asmType != 1" style="width: 80%;" placeholder="请输入"></el-input> -->
                    </el-form-item>
                    <el-form-item label="公章二纵向位置(一行约为24)" prop="asmrLocationTwoVertical">
                        <span style="margin-right: 10px;">向上移动</span> <el-input-number
                            v-model="formGg.asmrLocationTwoVertical" :step="24" style="width: 40%;" placeholder="请输入"
                            :disabled="formGg.asmType != 1"></el-input-number> <span
                            style="margin-left: 10px;">向下移动</span>
                        <!-- <el-input v-model="formGg.asmrLocationTwoVertical" type="number" :disabled="formGg.asmType != 1" style="width: 80%;" placeholder="请输入"></el-input> -->
                    </el-form-item>
                    <el-form-item label="公章三横向位置(一个字约为12)" prop="asmrLocationThreeHorizontal">
                        <span style="margin-right: 10px;">向左移动</span> <el-input-number
                            v-model="formGg.asmrLocationThreeHorizontal" :step="12" style="width: 40%;"
                            :disabled="formGg.asmType != 1" placeholder="请输入"></el-input-number> <span
                            style="margin-left: 10px;">向右移动</span>
                        <!-- <el-input v-model="formGg.asmrLocationThreeHorizontal" type="number" :disabled="formGg.asmType != 1" style="width: 80%;" placeholder="请输入"></el-input> -->
                    </el-form-item>
                    <el-form-item label="公章三纵向位置(一行约为24)" prop="asmrLocationThreeVertical">
                        <span style="margin-right: 10px;">向上移动</span> <el-input-number
                            v-model="formGg.asmrLocationThreeVertical" :step="24" style="width: 40%;" placeholder="请输入"
                            :disabled="formGg.asmType != 1"></el-input-number> <span
                            style="margin-left: 10px;">向下移动</span>
                        <!-- <el-input v-model="formGg.asmrLocationThreeVertical" type="number" :disabled="formGg.asmType != 1" style="width: 80%;" placeholder="请输入"></el-input> -->
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleWorkGgClose">取 消</el-button>
                    <el-button type="primary" @click="sureworkGg">确 定</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import fileDownload from 'js-file-download';
let Base64 = require('js-base64').Base64
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjSealModelRecordList, addAjSealModelRecord, updateAjClothesWare, deleteAjSealModelRecord, getAjClothesWareDetails, getAjClothesWareScaleList,
    updateAjClothesWareScale, updateAjSealModelRecordParams, deleteAjSealModelRecordScale, getAjSealModelList,
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            WorkGgShow: false,
            formGg: {
                asmrId: '',
                asmrFileName: '',
                asmrLocationOneHorizontal: '',
                asmrLocationOneVertical: '',
                asmrLocationTwoHorizontal: '',
                asmrLocationTwoVertical: '',
                asmrLocationThreeHorizontal: '',
                asmrLocationThreeVertical: '',
            },
            asmType_arr: [],
            TextFileList: [],
            DetailArr: '',
            asmId: '',
            IsDetail: false,
            fileList: [],
            key: 'asmId',
            dialog: false,
            edit: false,
            form: {
                asmType: '',
                file: '',
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "asmTypeDes",
                    key: "asmTypeDes",
                    title: "模板类型",
                    align: "center",
                    width: 200,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                >
                                    {row.asmTypeDes}
                                </el-button>

                            </span>
                        );
                    },
                },
                {
                    field: "asmrFileName",
                    key: "asmrFileName",
                    title: "文件名",
                    align: "center",
                    width: 200,

                },

                {
                    field: "asmrFilePathDocxOnline",
                    key: "asmrFilePathDocxOnline",
                    title: "文件",
                    align: "center",
                    width: 200,
                    edit: false,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.Preview(row.asmrFilePathPdfOnline)}
                                >
                                    预览
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.DownFile(row.asmrFilePathDocxOnline, row.asmrFileName)}
                                >
                                    下载word
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.DownFile(row.asmrFilePathPdfOnline, row.asmrFileName.split('.')[0] + ".pdf")}
                                >
                                    下载PDF
                                </el-button>


                            </span>
                        );
                    },
                },

                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                <el-button
                                    size="mini"
                                    type="text"
                                    on-click={() => this.handleEdit(row)}
                                >
                                    编辑参数
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="text"
                                    style="color: red"
                                    on-click={() => this.handleDelete(row)}
                                >
                                    删除
                                </el-button>
                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                acwName: '',
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
        getAjSealModelList().then(res => {
            this.asmType_arr = res.data
        })
    },
    mounted() { },
    methods: {
        fetchFileStream(url) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('GET', url, true);
                xhr.responseType = 'blob'; // 设置响应类型为Blob
                xhr.onload = function () {
                    if (this.status === 200) {
                        resolve(this.response);
                    } else {
                        reject(new Error('Error fetching file'));
                    }
                };
                xhr.send();
            });
        },
        DownFile(url, name) {
            // console.log(newUrl);
            axios({
                method: 'get',
                url: url,
                responseType: 'blob'
            }).then(res => {
                fileDownload(res.data, name);
            });
        },
        handlePreview(file) {
            console.log(file);
            this.textFle = file;
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        downloadFile(url, name) {
            if (!url) {
                return
            }
            let link = document.createElement('a');
            // link.style.display = 'none';
            link.href = url;
            // link.onload = function () {
            //     document.body.removeChild(link);
            // };
            console.log(name)
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        Preview(url) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url)));
        },
        textFIlePreview(index, key) {
            window.open('https://filepreview.aojuai.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(
                this.form[key][index].url)));
        },
        TextFileChange(file) {
            if (this.form.file && this.form.file.length > 0) {
                this.form.file.push(...file)
            } else {
                this.$set(this.form, 'file', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        handleWorkGgDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjClothesWareScale({ acwsId: row.acwsId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.getDetailList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleWorkGgEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formGg = data;
            this.workEdit = true;
            this.WorkGgShow = true
        },
        handleWorkGgClose() {
            this.$refs['formGg'].resetFields();
            this.WorkGgShow = false;

        },
        sureworkGg() {
            this.$confirm("是否确定要编辑, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var newForm = JSON.parse(JSON.stringify(this.formGg));
                    this.openLoading()
                    updateAjSealModelRecordParams(newForm).then(res => {
                        if (res.data) {
                            this.loadings.close()
                            this.$message({
                                type: "success",
                                message: "编辑成功!",
                            });
                            this.handleWorkGgClose()
                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getDetail(id) {
            this.acwId = this.formGg.acwId = id
            getAjClothesWareDetails({ acwId: id }).then(res => {
                this.DetailArr = res.data;
                this.IsDetail = true;
                getAjClothesWareScaleList({ acwId: id }).then(res => {
                    this.workClothesGg = res.data
                })
            })
        },
        getDetailList() {
            getAjClothesWareDetails({ acwId: this.acwId }).then(res => {
                this.DetailArr = res.data;
                getAjClothesWareScaleList({ acwId: this.acwId }).then(res => {
                    this.workClothesGg = res.data
                })
            })
        },
        removeAfter(file) {
            const url = this.form.acwImages.findIndex(item => item === file)
            this.form.acwImages.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            if (this.form.acwImages && this.form.acwImages.length > 0) {
                this.form.acwImages.push(...file)
            } else {
                this.$set(this.form, 'acwImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out(command) {
            console.log(command);
            if (this.selectedRowKeysCollection.length == 0 && !command) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0 && !command) {
                console.log('开始导出', this.selectedRowKeysCollection)
                const bulkdata = {
                    exportType: 2,
                    acwIds: this.selectedRowKeysCollection.toString(),
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-purchase-gift/exportAjPurchaseGift',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid'),
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '公章模板 .xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            } else {
                const bulkdata = {
                    exportType: 1,
                    ...this.formDatas
                }
                var s = qs.stringify(bulkdata);
                this.openLoading()
                var that = this
                axios({
                    method: 'post',
                    url: config.baseURL + '/aj-purchase-gift/exportAjPurchaseGift',
                    data: s,
                    // withCredentials: true,
                    timeout: 1200000,
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                        'userid': window.localStorage.getItem('userid')
                    }
                }).then(function (res) {
                    if (res.data) {
                        that.loadings.close()
                        let a = document.createElement('a');
                        //ArrayBuffer 转为 Blob
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel"
                        });
                        let objectUrl = URL.createObjectURL(blob);
                        a.setAttribute("href", objectUrl);
                        a.setAttribute("download", '公章模板 .xlsx');
                        a.click();
                        that.$message({
                            message: "成功",
                            type: "success"
                        });

                    }
                })
            }
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjSealModelRecord({ acwId: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjSealModelRecord({ asmrId: row.asmrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.formGg = data;
            this.WorkGgShow = true;

        },
        SureBtn() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let Data = new FormData();
                    Data.append('asmType', this.form.asmType)
                    Data.append('file', this.textFle.raw)
                    this.openLoading()
                    addAjSealModelRecord(Data).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.loadings.close()
                            this.handleClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.$refs.Upload.clearFiles()
            this.fileList = [];
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.acwId = row.acwId
                    console.log(jsonObj);
                    updateAjClothesWare(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {
            const rowKey = row[key];
            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjSealModelRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjSealModelRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjSealModelRecordList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>